import { useNavigate } from 'react-router-dom'
import { Button } from '@rammetec/design-system'

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-10 text-center">
      <div className="text-4xl font-bold text-foreground">404</div>
      <div className="text-sm text-muted-foreground">Página não encontrada.</div>
      <Button variant="outline" onClick={() => navigate('/')}>
        Voltar ao início
      </Button>
    </div>
  )
}
